import { Appointment } from "api/types/appointments";

export interface ClinicianBasicInfo {
  id: string;
  first_name: string;
  last_name: string;
  image_url: string | null;
}

export type Appointments = Appointment[];

export enum UserTaskType {
  IMAGE_UPLOAD = "image_upload",
  VIDEO_CALL_SIGNATURE = "video_call_signature",
  TREATMENT_PLAN_SIGNATURE = "treatment_plan_signature",
  NINETY_DAY_PROGRESS_SIGNATURE = "ninety_day_progress_signature",
  FILLOUT_IFRAME = "fillout_iframe",
  OTHER_CONSENT_FORMS = "other_consent_forms",
  TECH_CHECK = "tech_check",
}
